<script lang="ts">
    import { onMount } from 'svelte'
    import type { Person } from '../../../modules/eventsApi/persons/person'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    dayjs.locale('pt-br')

    let show = false

    let data: Person[] = []
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        data = await window.api.events.persons.getAll({ from, to, limit: 999999 })
        console.log('relat.data', data)
        loadGrid()
        show = false
        console.log('relat.grid', grid)
    }

    let grid: GridClass = null
    function loadGrid() {
        grid = new GridClass()
        grid.title = 'Pessoas Cadastradas'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: 'Nascimento', type: GridColTypeEnum.date }))
        if (showAll) {
            grid.cols.push(new GridCol({ content: 'CPF/CNPJ' }))
            grid.cols.push(new GridCol({ content: 'RG' }))
            grid.cols.push(new GridCol({ content: 'Sexo' }))
            grid.cols.push(new GridCol({ content: 'Endereço' }))
            grid.cols.push(new GridCol({ content: 'Anotações' }))
        }
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        for (const person of data) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: person.createdAt })
            line.slots.push({ content: person.name })
            line.slots.push({ content: person.phone })
            line.slots.push({ content: person.email })
            line.slots.push({ content: person.born })
            let gender = ''
            if (person.gender === 'male') gender = 'Masculino'
            if (person.gender === 'female') gender = 'Feminino'
            if (person.gender === 'other') gender = 'Outro'

            if (showAll) {
                let address = person.address ? person.address : ''
                address += person.number ? ' - ' + person.number : ''
                address += person.complement ? ' - ' + person.complement : ''
                address += person.district ? ' - ' + person.district : ''
                address += person.city ? ' - ' + person.city : ''
                address += person.state ? ' - ' + person.state : ''
                address += person.CEP ? ' - ' + person.CEP : ''
                line.slots.push({ content: person.document })
                line.slots.push({ content: person.RG })
                line.slots.push({ content: gender })
                line.slots.push({ content: address })
                line.slots.push({ content: person.comments })
            }
            line.slots.push({ content: [new GridButton({ callback: () => window.person('show', person.personId), icon: faUser })] })
            grid.lines.push(line)
        }
    }

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()
    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }

    let showAll = false
    function toggleShowAll(event) {
        console.log('toggle', showAll, event.detail)
        loadGrid()
    }
</script>

<div class="relat-body">
    <div class="acts h-print d-flex">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
        <div class="spacer"></div>
        <div>
            <Zinput type="toggle" on:change={toggleShowAll} bind:value={showAll} label="Exibir todos os dados"></Zinput>
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
